'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { extractUtmParams, storeUtmParams } from '@/lib/utm-tracking';

/**
 * Global UTM Tracking Provider
 * 
 * This component should be added to the root layout to ensure UTM parameters
 * are captured on every page load across the entire application.
 * 
 * It tracks UTM parameters from URL query strings and stores them in sessionStorage
 * so they persist across page navigations and can be used in form submissions.
 */
export function UtmTrackingProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    // Extract UTM parameters from current URL on every page navigation
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search);
      const urlUtmParams = extractUtmParams(searchParams);
      
      // If we found UTM parameters in the URL, store them
      if (Object.keys(urlUtmParams).length > 0) {
        storeUtmParams(urlUtmParams);
      }
    }
  }, [pathname]); // Re-run when pathname changes
  
  return <>{children}</>;
}

